import { render, staticRenderFns } from "./x-onboarding.vue?vue&type=template&id=a4ffe4f4&"
import script from "./x-onboarding.vue?vue&type=script&lang=js&"
export * from "./x-onboarding.vue?vue&type=script&lang=js&"
import style0 from "./x-onboarding.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VApp,VProgressCircular,VRow})
